import { render } from "./RPG.vue?vue&type=template&id=5f7c8ff8"
const script = {}
script.render = render

export default script